var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_10554",
    gradientUnits: "userSpaceOnUse",
    x1: 1.25,
    x2: 22.75,
    y1: 1.25,
    y2: 22.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b288bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65008d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 1.25c-5.93706 0-10.75 4.81294-10.75 10.75 0 5.9371 4.81294 10.75 10.75 10.75 5.9371 0 10.75-4.8129 10.75-10.75 0-5.93706-4.8129-10.75-10.75-10.75zm-.0084 5c-1.7958 0-3.25352 1.45407-3.25352 3.25 0 1.7959 1.45772 3.25 3.25352 3.25 1.7959 0 3.2536-1.4541 3.2536-3.25 0-1.79593-1.4577-3.25-3.2536-3.25zm5.0493 10.2302c-2.6674-2.88-7.46618-2.7315-10.07708-.0046l-.18751.1875c-.14527.1453-.22459.3438-.21943.5492s.09434.3997.24672.5375c1.37409 1.2425 3.1977 2.0002 5.1965 2.0002s3.8224-.7577 5.1965-2.0002c.1524-.1378.2416-.3321.2467-.5375.0052-.2054-.0741-.4039-.2194-.5492z",
    fill: "url(#paint0_linear_6_10554)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.104b6d37ace1995bb15678fd01706dd6.svg";
export { ForwardRef as ReactComponent };